

































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import WardSelector from "@/modules/regions/WardSelector/index.vue";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import {PostOfficeStore} from "@/modules/postoffices/store";
import {assignValueToForm} from "@/shared/services/helper/utils";
import FreightServiceSelector from "@/shared/components/FreightServiceSelector/index.vue";
import {PHONE_REGEX} from "@/shared/constant";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {CommonStatus} from "@/enums/status";

@Component({
    name: "PostOfficeForm",
    components: {
        EnumSelector,
        FreightServiceSelector, MillisecondDatePicker, WardSelector, DistrictSelector, ProvinceSelector}
})
export default class extends Vue {
    @Prop()
    readonly id!: string;

    CommonStatus = CommonStatus;
    
    private form = {
        rowGuid: "",
        postOfficeCode: "",
        name: "",
        phoneNumber: "",
        taxCode: "",
        bankAccount: "",
        bankName: "",
        address: "",
        wardId: undefined,
        districtId: undefined,
        provinceId: undefined,
        directorName: "",
        directorPhone: "",
        lockAt: undefined,
        status: undefined
    };

    private rules = {
        postOfficeCode: [{ required: true, message: "Nhập mã bưu cục", trigger: "change" }],
        name: [{ required: true, message: "Nhập tên bưu cục", trigger: "change" }],
        phoneNumber: [
            { required: true, message: "Nhập số điện thoại bưu cục", trigger: "change" },
            { pattern: new RegExp(PHONE_REGEX), message: "Số điện thoại không đúng định dạng", trigger: "change" },
        ],
        taxCode: [{ required: true, message: "Nhập mã số thuế", trigger: "change" }],
        bankAccount: [{ required: true, message: "Nhập số tài khoản ngân hàng", trigger: "change" }],
        bankName: [{ required: true, message: "Nhập tên ngân hàng", trigger: "change" }],
        address: [{ required: true, message: "Nhập địa chỉ", trigger: "change" }],
        wardId: [{ required: true, message: "Chọn phường/xã", trigger: "change" }],
        districtId: [{ required: true, message: "Chọn quận/huyện/tp", trigger: "change" }],
        provinceId: [{ required: true, message: "Chọn tỉnh/thành phố", trigger: "change" }],
        directorName: [{ required: true, message: "Nhập tên giám đốc", trigger: "change" }],
        directorPhone: [
            { required: true, message: "Nhập số điện thoại giám đốc", trigger: "change" },
            { pattern: new RegExp(PHONE_REGEX), message: "Số điện thoại không đúng định dạng", trigger: "change" }
        ],
        lockAt: [{ required: false }],
        status: [{ required: false }],
    };

    private onSubmit() {
        (this.$refs.formPostOffice as FormModel).validate(async valid => {
            if (!valid) return;
            try {
                this.id
                    ? await PostOfficeStore.updatePostOffice(this.form)
                    : await PostOfficeStore.createPostOffice(this.form);
                this.$notification.success({
                    message: "Thành công",
                    description: `${this.id ? 'Sửa' : 'Tạo'} bưu cục thành công`
                });
                this.$router.push({ name: "listPostOffices" });
            } catch (e) {
                this.$notification.error({
                    message: "Thất bại",
                    description: `${e.response?.data?.message || `${this.id ? 'Tạo' : 'Sửa'} bưu cục thất bại`}`
                })
            }
        })
    }

    async created() {
        if (this.id) {
            try {
                const data = await PostOfficeStore.singlePostOffice(this.id);
                this.form = assignValueToForm(this.form, data);
            } catch (e) {
                this.$notification.error({
                    message: "Thất bại",
                    description: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
                })
            }
        }
    }
}
